import { UNLEASH_TOGGLES } from './types';
import unleashClient from './unleashClient';

export class FeatureFlag {
  public static isKingJamesTranslationEnabled = false;
  public static isMediaSuppressProgressTrackingActive = false;
  public static isGroupAttendanceEnabled = false;

  public static setup(): void {
    this.isMediaSuppressProgressTrackingActive = unleashClient.isEnabled(
      UNLEASH_TOGGLES.MEDIA_SUPPRESS_PROGRESS_TRACKING
    );

    this.isKingJamesTranslationEnabled = unleashClient.isEnabled(
      UNLEASH_TOGGLES.MEDIA_KING_JAMES_TRANSLATION
    );
    this.isGroupAttendanceEnabled = unleashClient.isEnabled(
      UNLEASH_TOGGLES.DISPATCH_GROUP_ATTENDANCE
    );
  }
}
